/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Creatingaccount1Inputs */

const zh_auth_creatingaccount1 = /** @type {(inputs: Auth_Creatingaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建中...`)
};

const en_auth_creatingaccount1 = /** @type {(inputs: Auth_Creatingaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating account...`)
};

const es_auth_creatingaccount1 = /** @type {(inputs: Auth_Creatingaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando cuenta...`)
};

/**
* | output |
* | --- |
* | "Creating account..." |
*
* @param {Auth_Creatingaccount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_creatingaccount1 = /** @type {((inputs?: Auth_Creatingaccount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Creatingaccount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_creatingaccount1(inputs)
	if (locale === "en") return en_auth_creatingaccount1(inputs)
	return es_auth_creatingaccount1(inputs)
});
export { auth_creatingaccount1 as "auth_creatingAccount" }